import React from 'react';
import { SearchResultItem } from '../types/api.types';
import { ResultItem } from './ResultItem';

interface SearchResultsProps {
  results: SearchResultItem[];
  total: number;
  query: string;
  searchTime?: number;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  total,
  query,
  searchTime,
}) => {
  if (results.length === 0) {
    return (
      <div className="text-center py-12">
        <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p className="text-gray-600 text-lg">No se encontraron resultados</p>
        <p className="text-gray-400 text-sm mt-2">
          Intenta con otros términos de búsqueda o ajusta los filtros
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Results info */}
      <div className="text-sm text-gray-600">
        Aproximadamente {total} resultado{total !== 1 ? 's' : ''}
        {searchTime !== undefined && ` (${searchTime.toFixed(2)} segundos)`}
      </div>

      {/* Results list */}
      <div className="space-y-8">
        {results.map((result) => (
          <ResultItem key={result.id} result={result} />
        ))}
      </div>
    </div>
  );
};
